<template>
  <div id="banned-country" style="max-width: 32rem;">
    <ds
      ds="tag"
      version="warning"
      icon="info"
      :label="$t('view.BannedCountry.title')"
      size="lg"
      iconSize="1em"
      isSquare
      class="_m:top(3) _p(3)"
      style="width: 100%;"
    />
    <div class="_flex:column _m:top(4) _p:x(3) _m:x(1)">
      <p class="h6 _m:top(2) _m:bottom(4)">
       {{ $t('view.BannedCountry.subtitle')}}
      </p>
      <p class="_text:sm _m:bottom(3)">
        {{ $t('view.BannedCountry.description')}}
      </p>
      <p class="_text:sm _m:bottom(5)">
        {{ $t('view.BannedCountry.greeting')}}
      </p>

      <ds
        ds="button"
        :label="$t('shared.action.signOut')"
        mode="outlined"
        @click="this.signOut"
        icon="open-to-left"
        iconSize="12px"
        isReverse
        class="_m:bottom(5)"
        id="sign-out"
      />

       <p v-html="$t('shared.action.contactUs')" class="_text:sm _text-grey-900 _m:x(auto) _m:bottom(0)"/>

    </div>

  </div>
</template>

<script>
import { authHelper } from '@/mixins';
export default {
  name: 'BannedCountry',
  mixins: [authHelper],
  watch: {
    isLoggedIn () {
      if (!this.isLoggedIn) {
        this.$router.replace({ name: 'sign-in' });
      }
    }
  }
};
</script>
